import { inject, Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { InventoryTransactionService } from '../base-actions/inventory-transaction.service';
import { InventoryTransactionProxyService } from '../../proxies/inventory/inventory-transaction.proxy.service';
import { RollProxyService } from '../../proxies/production/roll.proxy';
import { LocationProxyService } from '../../proxies/inventory/location.proxy.service';

export type InventoryTransactionManagerKey = 'warehouse-import' | 'requisition-details' | 'transfer-unit-details';

@Injectable({
  providedIn: 'root',
})
export class InventoryTransactionManagerFactory {
  private readonly inventoryTransactionProxyService = inject(InventoryTransactionProxyService);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly rollProxyService = inject(RollProxyService);
  private readonly translateService = inject(TranslateService);
  private readonly locationProxyService = inject(LocationProxyService);

  private managers = new Map<string, InventoryTransactionService>();

  createManager(key: InventoryTransactionManagerKey): InventoryTransactionService {
    if (this.managers.has(key)) {
      return this.managers.get(key)!;
    }

    const manager = new InventoryTransactionService(
      this.inventoryTransactionProxyService,
      this.confirmationService,
      this.rollProxyService,
      this.translateService,
      this.locationProxyService,
    );
    manager.setType(key);
    this.managers.set(key, manager);
    return manager;
  }

  getManager(key: InventoryTransactionManagerKey): InventoryTransactionService | undefined {
    return this.managers.get(key);
  }

  deleteManager(key: InventoryTransactionManagerKey): void {
    this.managers.delete(key);
  }
}
